import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { TylTranslation } from '../models/tyl-translation.model';
import { HttpClient } from '@angular/common/http';
import { System } from '../System';

@Injectable()
export class TranslationService {

	public overrideTranslationPipe: boolean = false;
	public revertToEnglish: boolean = false;
	public overrideTranslations: TylTranslation[] = [];
	public currentLanguageTranslations: TylTranslation[] = [];

	public _currentLanguage = 'en';
	public observableCurrentLanguage = new Subject<string>();
	observableCurrentLanguageStream$ = this.observableCurrentLanguage.asObservable();
	public get currentLanguage(): string {
		return this._currentLanguage;
	}

	public set currentLanguage(value: string) {
		this._currentLanguage = value;
		this.setTranslationLanguage();
		this.getLanguageTranslations();
		this.observableCurrentLanguage.next(value);
	}

	constructor(private translateService: TranslateService,
		private http: HttpClient) {

	}

	setTranslationLanguage() {
		setTimeout(() => {
			this.translateService.use(this.currentLanguage);
		}, 0);
	}

	public getLanguageTranslations() {
		let language_ID: number;

		//  TODO change to dto lookup
		//  language must be 'en' for English, 'fr' for French, or 'es' for Spanish, or 'pt' for portuguese
		switch (this.currentLanguage) {
			case 'fr':
				language_ID = 7;
				break;
			case 'es':
				language_ID = 1;
				break;
			case 'pt':
				language_ID = 107;
				break;
			default:
				// en
				language_ID = 9;
		}

		this.getTranslationsForLanguage(language_ID).subscribe(result => {
			if (result) {
				this.currentLanguageTranslations = result;
			}
		});
	}

	getLanguageId(iso: string): number {
		let language_ID: number;

		switch (iso) {
			case 'fr':
				language_ID = 7;
				break;
			case 'es':
				language_ID = 1;
				break;
			case 'pt':
				language_ID = 107;
				break;
			default:
				// en
				language_ID = 9;
		}

		return language_ID;
	}

	getLanguageCode(id: number): string {
		let languageCode: string;

		switch (id) {
			case 7:
				languageCode = 'fr';
				break;
			case 1:
				languageCode = 'es';
				break;
			case 107:
				languageCode = 'pt';
				break;
			default:
				//9
				languageCode = 'en';
		}

		return languageCode;

	}

	//------------------------------------------------------------------------------------

	getTranslations(english: string[], language_ID: number): Observable<TylTranslation[]> {
		const queryString = '?language_ID=' + language_ID;
		return this.http.post<TylTranslation[]>(System.apiURL.Student + 'GetTranslations' + queryString, english);
	}

	getTranslationsWithRichText(english: TylTranslation[], language_ID: number): Observable<TylTranslation[]> {
		const queryString = '?language_ID=' + language_ID;
		return this.http.post<TylTranslation[]>(System.apiURL.Student + 'GetTranslationsWithRichText' + queryString, english);
	}

	getTranslationStatusForLanguages(english: TylTranslation[]): Observable<TylTranslation[]> {
		return this.http.post<TylTranslation[]>(System.apiURL.Student + 'GetTranslationStatusForLanguages', english);
	}

	getTranslationsForLanguage(language_ID: number): Observable<TylTranslation[]> {
		const queryString = '?language_ID=' + language_ID;
		return this.http.get<TylTranslation[]>(System.apiURL.Student + 'GetTranslationsForLanguage' + queryString);
	}

	saveTranslations(translations: TylTranslation[], language_ID: number): Observable<TylTranslation[]> {
		const queryString = '?language_ID=' + language_ID;
		return this.http.post<TylTranslation[]>(System.apiURL.Student + 'SaveTranslations' + queryString, translations);
	}
}

